<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              :items="requestTypes"
              label="Type de requête"
              item-text="label"
              item-value="value"
              v-model="selectedRequest"
            ></v-select>
            <v-text-field
              label="Company Id"
              v-model="companyId"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col style="text-align: center">
            <v-date-picker
              v-model="dates"
              range
            ></v-date-picker>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary" @click="fetchData">Valider
        </v-btn>
        <v-btn
          color="primary"
          v-if="rows && rows.length"
          @click="exportToExcel">Exporter en Excel</v-btn>

      </v-card-actions>
    </v-card>
    <br/>
    <v-data-table
      dense
      :headers="headers"
      :items="rows"
      :items-per-page="-1"
      :footer-props="{
          'itemsPerPageText': $t('Dashboard.rowsPerPage')
      }"

    ></v-data-table>
    <br/>
    <v-alert
      elevation="1"
      v-if="sql"
    >
      <pre>{{ sql }}</pre>
    </v-alert>
  </v-container>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      requestTypes: [
        {label : "Syndic", value : "billing-transfer"},
        {label : "Gérance", value : "billing-active-keys"},
        {label : "Gérance/Keys", value: "billing-active-all-keys"},
        {label : "Syndic & Gérance", value : "billing-per-boxes"},
        {label : "SMS", value : "billing-sms"},
        {label : "Duplicate", value : "duplicate"},
        {label : "Connected Codes", value : "connected-codes"},
        {label : "Transfers", value : "tranfers-details"},
        {label : "Utilisateur unique ayant pris une clé", value : "unique-user-withdraw"},
        {label : "Utilisateur unique ayant deposé une clé ", value : "unique-user-drop"},
        {label : "Liste des clés de la companie avec quelqu'un (NO DATE)", value : "key-holding-list"},
      ],
      selectedRequest: "billing-transfer",
      companyId: null,
      dates: this.getCurrentMonthRange(),
      rows: [],
      sql: null,
      headers: []
    };
  },
  methods: {
    fetchData() {
      this.$store.dispatch("admin/sql/sendRequest", {
        type: this.selectedRequest,
        companyId: this.companyId,
        startDate: this.getEarliestDate(this.dates),
        endDate: this.getNextDay(this.getLatestDate(this.dates))
      }).then(data => {
        this.rows = data.rows;
        this.sql = data.sql;
        this.headers = this.getDistinctAttributes(this.rows).map(
          header => ({text: header, value: header, sortable: false})
        );
      }).catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      });
    },

    getDistinctAttributes(arr) {
      return [...arr.reduce((acc, obj) => {
        Object.keys(obj).forEach(key => acc.add(key));
        return acc;
      }, new Set())];
    },
    getEarliestDate(dates) {
      return new Date(Math.min(...dates.map(date => new Date(date))));
    },
    getLatestDate(dates) {
      return new Date(Math.max(...dates.map(date => new Date(date))));
    },
    getNextDay(date) {
      let nextDay = new Date(date);
      nextDay.setDate(date.getDate() + 1);
      return nextDay;
    },
    getCurrentMonthRange() {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      function formatDate(date) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }

      return [formatDate(startOfMonth), formatDate(endOfMonth)];
    },
    exportToExcel() {
      const ws = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `${this.selectedRequest}_${this.companyId}_${this.getEarliestDate(this.dates).toLocaleDateString("fr")}_${this.getLatestDate(this.dates).toLocaleDateString("fr")}.xlsx`);
    }
  }
};
</script>
